export const SET_RETIREMENT_DATA = 'SET_RETIREMENT_DATA';
